import ProductCardComponent from './ProductCardComponent'

export default ProductCardComponent
